<template>
  <div>
    <b-form-group :label="label" :label-for="id" :description="description">
      <b-form-textarea :maxlength="maxlength" :rows="rows" :max-rows="maxRows" :id="id" v-model="localValue" :placeholder="placeholder" style="overflow:hidden" :readonly="readOnly" :no-resize="noResize">
      </b-form-textarea>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'base-textarea',
  components: {
    BFormGroup,
    BFormTextarea
  },
  props: {
    value: String,
    rows: {
      type: Number,
      required: false,
      default: null
    },
    maxRows: {
      type: Number,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    maxlength: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default () {
        return this.$t('appointment-notes.write-here')
      }
    },
    noResize: Boolean,
    readOnly: Boolean
  },
  data () {
    return {
      id: null,
      localValue: null
    }
  },
  mounted () {
    this.id = this._uid.toString()
  },
  created () {
    this.localValue = this.value
    this.$watch('value', value => {
      this.localValue = value
    })
    this.$watch('localValue', value => {
      this.$emit('input', value)
      this.$emit('change', value)
    })
  }
}
</script>

<style lang="scss" scoped>
.text-align-left{
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseTextarea.vue